import Ajax from '../ajax';

export default {
  list: (merchantId, data) => Ajax('get', `merchant/${merchantId}/store`, data),
  get: (merchantId, storeId) => Ajax('get', `merchant/${merchantId}/store/${storeId}`),
  add: (merchantId, data) => Ajax('post', `merchant/${merchantId}/store`, data),
  edit: (merchantId, storeId, data) => Ajax('put', `merchant/${merchantId}/store/${storeId}`, data),
  mainStore: (merchantId, storeId) => Ajax('put', `merchant/${merchantId}/store/${storeId}/main`),
  delete: (merchantId, storeId) => Ajax('delete', `merchant/${merchantId}/store/${storeId}`),

  listAdmins: (merchantId, storeId) => Ajax('get', `merchant/${merchantId}/store/${storeId}/admins`),
  addAdmin: (merchantId, storeId, userId) => Ajax('post', `merchant/${merchantId}/store/${storeId}/admins/${userId}`),
  deleteAdmin: (merchantId, storeId, userId) => Ajax('delete', `merchant/${merchantId}/store/${storeId}/admins/${userId}`),
};
